import { excuseApi } from '../commons/http';
import Supplier from '../models/supplier';

export const getSuppliers = async (params) => {
  const res = await excuseApi({
    path: '/suppliers',
    method: 'GET',
    params,
  });
  return res.data;
};

export const getSupplier = async (id) => {
  const res = await excuseApi({
    path: `/suppliers/${id}`,
    method: 'GET',
  });
  const supplier = new Supplier();
  supplier.mapData(res.data.data);
  return supplier;
};

export const createSupplier = async (data) => {
  const res = await excuseApi({
    path: '/suppliers',
    method: 'POST',
    body: data,
  });
  return res.data;
};

export const updateSupplier = async (id, data) => {
  const res = await excuseApi({
    path: `/suppliers/${id}`,
    method: 'PUT',
    body: data,
  });
  return res.data;
};

export const patchSupplier = async (id, data) => {
  const res = await excuseApi({
    path: `/suppliers/${id}`,
    method: 'PATCH',
    body: data,
  });
  return res.data;
};

export const addProductToSupplier = async (supplierId, productId) => {
  const res = await excuseApi({
    path: `/suppliers/${supplierId}/products`,
    method: 'POST',
    body: { product_id: productId },
  });
  return res.data;
};

export const removeProductFromSupplier = async (supplierId, productId) => {
  const res = await excuseApi({
    path: `/suppliers/${supplierId}/products/${productId}`,
    method: 'DELETE',
  });
  return res.data;
};

export const addSupplierProductCost = async (supplierProductId, data) => {
  const res = await excuseApi({
    path: `/suppliers/products/${supplierProductId}/costs`,
    method: 'POST',
    body: data,
  });
  return res.data;
};

export const getSupplierProductCostHistory = async (supplierProductId) => {
  const res = await excuseApi({
    path: `/suppliers/products/${supplierProductId}/costs`,
    method: 'GET',
  });
  return res.data;
};

// Finance endpoints
export const getSupplierFinance = async (supplierId) => {
  const res = await excuseApi({
    path: `/suppliers/${supplierId}/finance`,
    method: 'GET',
  });
  return res.data;
};

export const markSupplierPOsPaid = async (supplierId, data) => {
  const res = await excuseApi({
    path: `/suppliers/${supplierId}/mark-paid`,
    method: 'POST',
    body: data,
  });
  return res.data;
}; 